module.exports = __webpack_public_path__ + "static/media/pl-lk-3.d7c0ed0f.jpg";